import {
  BreadcrumbLevel,
  Breadcrumbs,
} from '@app/components/core/breadcrumbs/Breadcrumbs'

export type RegionalBreadcrumbsProps = {
  regionName: string
  regionHomePath: string
  sectionLabel: string
  sectionPath: string
  articleTitle?: string
}

export const RegionalBreadcrumbs = ({
  regionName,
  regionHomePath,
  sectionLabel,
  sectionPath,
  articleTitle,
}: RegionalBreadcrumbsProps) => {
  const levels: BreadcrumbLevel[] = [
    { label: regionName, to: regionHomePath },
    { label: sectionLabel, to: articleTitle ? sectionPath : undefined },
  ]

  if (articleTitle) {
    levels.push({ label: articleTitle })
  }

  return <Breadcrumbs levels={levels} />
}
